// extracted by mini-css-extract-plugin
module.exports = {"heroHeadContainer":"HeroHead_heroHeadContainer__Yxj9Q","head":"HeroHead_head__KRMya","label":"HeroHead_label__iXJa_","meta":"HeroHead_meta__ychx8"};